import { useState, useEffect } from 'react';
import Marquee from 'react-fast-marquee';
import apiClient from '@/lib/api';

const AnnouncementBar = () => {
  const [announcements, setAnnouncements] = useState([
    "NEW INSPIRED LOOKS EVERY WEEK",
    "AS SEEN ON TIKTOK",
    "CURATED BY COOL GIRLS, FOR COOL GIRLS",
    "AMAZON FINDS I ACTUALLY LOVE",
  ]);

  useEffect(() => {
    loadAnnouncements();
  }, []);

  const loadAnnouncements = async () => {
    try {
      const response = await apiClient.get('/announcements');
      if (response.data && response.data.length > 0) {
        const activeTexts = response.data
          .filter(a => a.active)
          .map(a => a.text);
        if (activeTexts.length > 0) {
          setAnnouncements(activeTexts);
        }
      }
    } catch (error) {
      // Keep default announcements on error
      console.log('Using default announcements');
    }
  };

  // Calculate spacing based on number of announcements
  // More phrases = less spacing, fewer phrases = more spacing
  const getSpacing = () => {
    const count = announcements.length;
    if (count <= 1) return 'mx-16';
    if (count <= 2) return 'mx-12';
    if (count <= 3) return 'mx-10';
    return 'mx-8';
  };

  // Don't render if no announcements
  if (announcements.length === 0) {
    return null;
  }

  return (
    <div 
      className="bg-site-bg-dark text-white py-2 border-b border-site-bg-dark"
      data-testid="announcement-bar"
    >
      <Marquee speed={40} gradient={false}>
        {/* Render announcements multiple times to ensure smooth continuous scroll */}
        {[...Array(3)].map((_, setIndex) => (
          announcements.map((text, index) => (
            <span
              key={`${setIndex}-${index}`}
              className={`font-mono text-xs uppercase tracking-widest ${getSpacing()}`}
            >
              {text}
            </span>
          ))
        )).flat()}
      </Marquee>
    </div>
  );
};

export default AnnouncementBar;
